<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://sinargroup.my" target="_blank">Sinar Group</a>
      <span class="ml-1">&copy; {{ year }} ·</span>
      <span class="ml-1">{{ version }}</span>
      <span v-if="buildDate" class="ml-1 text-muted small">· Built {{ buildDate }}</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="https://sinargroup.my">Sinar Group</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: "TheFooter",
  computed: {
    version() {
      // Compile-time env var written by the build script before each docker
      // build. Falls back to the runtime window.config for backwards
      // compatibility on instances built before this change.
      return (
        process.env.VUE_APP_VERSION ||
        (typeof window !== "undefined" && window.config && window.config.VERSION) ||
        ""
      );
    },
    buildDate() {
      const raw = process.env.VUE_APP_BUILD_DATE;
      if (!raw) return "";
      const d = new Date(raw);
      if (isNaN(d.getTime())) return raw;
      return d.toLocaleString("en-MY", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    },
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>
